module.exports = __webpack_public_path__ + "img/birdcage1.adc7ff0e.png";